import { legacy_createStore as createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './reducers/index';
import rootSaga from './sagas/index';
import persistStore from 'redux-persist/es/persistStore';
import { persistedReducer } from '../storage/persistConfig';
import { createLogger } from 'redux-logger';

const sagaMiddleware = createSagaMiddleware();
const isDev = process.env.NODE_ENV === 'development';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

//const reduxDevTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
//const isDevToolsLogsEnableForProd = true;

const logger = createLogger({
    collapsed: (getState, action, logEntry) => true, // or false or function
    duration: true,             // Shows duration of action
    timestamp: true,            // Adds timestamp to logs
    level: {
        prevState: 'log',         // or 'warn', 'error', 'info'
        action: 'log',
        nextState: 'log',
        error: 'error'
    },
    colors: {
        title: () => '#00FF00',
        prevState: () => '#00FF00',
        action: () => '#00FF00',
        nextState: () => '#00FF00',
        error: () => '#FF0000',
    },
    titleFormatter: (action, time, took) =>
        `ACTION: ${action.type} @ ${time} (in ${took.toFixed(2)} ms)`,

    // Transform state/action for readability
    stateTransformer: state => state,
    actionTransformer: action => action,
    errorTransformer: error => error,

    // Log action if returns true
    //predicate: (getState, action) => true,

    // Show/hide diff
    //diff: true,

    // Collapse logs based on condition
    collapsed: (getState, action, logEntry) => true,
});

const middlewareList = [sagaMiddleware];

if (isDev) {
    middlewareList.push(logger);
}


/**
 * Before Build Command Used
 */
// const middleware = window.__REDUX_DEVTOOLS_EXTENSION__ && process.env.NODE_ENV === "development" && isDevToolsLogsEnableForProd
//          ? composeEnhancers(applyMiddleware(sagaMiddleware,(process.env.NODE_ENV === 'development' && isDevToolsLogsEnableForProd) && logger), reduxDevTools)
//          : composeEnhancers(applyMiddleware(sagaMiddleware,(process.env.NODE_ENV === 'development' && isDevToolsLogsEnableForProd) && logger));
//const store = createStore(rootReducer,middleware);

//const store = createStore(rootReducer,applyMiddleware(middlewareList),reduxDevTools);
//const storeWithDataPersist = createStore(persistedReducer,middleware);
//const persistor = persistStore(storeWithDataPersist);

const store = createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewareList)));
sagaMiddleware.run(rootSaga);

export {
    store,
    //persistor
};